import { render, staticRenderFns } from "./RegInspecRezultat.vue?vue&type=template&id=b3bac4a8"
import script from "./RegInspecRezultat.vue?vue&type=script&lang=js"
export * from "./RegInspecRezultat.vue?vue&type=script&lang=js"
import style0 from "./RegInspecRezultat.vue?vue&type=style&index=0&id=b3bac4a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports